/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Assign_IncomingInputs */

const vi_reconcile_assign_incoming = /** @type {(inputs: Reconcile_Assign_IncomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền về tài khoản`)
};

/**

* @param {Reconcile_Assign_IncomingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_assign_incoming = /** @type {((inputs?: Reconcile_Assign_IncomingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Assign_IncomingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_assign_incoming(inputs)
});